import { FunctionComponent, ReactNode } from 'react';
import {
  Flex,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';

export type WizardStep = {
  title: string;
  content: ReactNode;
};

type SeasonWizardTabsProps = {
  steps: WizardStep[];
  tabIndex: number;
  /** Maior índice de aba já liberado (0-based). */
  furthestStep: number;
  onTabChange: (index: number) => void;
};

export const SeasonWizardTabs: FunctionComponent<SeasonWizardTabsProps> = ({
  steps,
  tabIndex,
  furthestStep,
  onTabChange,
}) => (
  <Tabs
    variant="unstyled"
    index={tabIndex}
    onChange={onTabChange}
    bg="white"
    borderRadius="card"
    shadow="md"
  >
    <TabList borderBottomWidth="1px" borderColor="gray.100" px={{ base: 2, md: 4 }}>
      {steps.map((step, index) => (
        <Tab
          key={step.title}
          isDisabled={index > furthestStep}
          py={4}
          color="gray.400"
          fontWeight="medium"
          _selected={{ color: 'brand.500', fontWeight: 'semibold' }}
        >
          <Flex align="center" gap={2}>
            {index < furthestStep ? (
              <ChakraFeatherIcon name="check-circle" boxSize="16px" color="green.500" />
            ) : null}
            {`${index + 1}. ${step.title}`}
          </Flex>
        </Tab>
      ))}
    </TabList>

    <TabIndicator mt="-1.5px" height="2px" bg="brand.500" borderRadius="1px" />

    <TabPanels>
      {steps.map(step => (
        <TabPanel key={step.title} px={{ base: 4, md: 8 }} py={{ base: 5, md: 8 }}>
          {step.content}
        </TabPanel>
      ))}
    </TabPanels>
  </Tabs>
);
